module.exports = __webpack_public_path__ + "img/dump_driving.5e5950f0.svg";